module.exports = __webpack_public_path__ + "static/media/o.c0fe9752.png";